<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgement</h1>
<p>To my long-suffering book club buddies, thank you for swallowing your judgement. Your open-mouthed horror provided more encouragement than helpful comments could.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?415acaaa